/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.customers.modals.order.controllers', [
  'ui.bootstrap'
])

.controller('CustomersModalsOrderController', ['$scope', '$uibModalInstance', 'customer', function($scope, $uibModalInstance, customer) {

    $scope.customersModalsOrder = {

      model: {
        customer: customer,
        type: 'individual',
        params: {}
      },

      init: function() {
        this.model.params.customerId = customer.id;
      },

      done: function() {

        if (this.model.type === 'organization') {
          // Move orgId to accountId because create order page
          // accepts accountId as a query parameter and not orgId
          if (customer.orgId) {
            this.model.params.accountId = customer.orgId;
          }
        }

        $uibModalInstance.close(this.model);
      },

      cancel: function() {
        $uibModalInstance.dismiss();
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.customersModalsOrder.init();

}]);